<template>
  <v-checkbox
    v-model="checkbox"
    :label="item.NameInHebrew"
    text
    solo
    :color="color"
    class="rtl pa-0 dr-checkbox ma-0 black--text"
    hide-details
    :disabled="disabled"
    required
    @change="displaySelection"
  />
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: false,
      default: 'text',
    },

    item: {
      type: Object,
      required: true,
      default: () => {},
    },
    color: {
      type: String,
      required: false,
      default: 'orange',
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      checkbox: false,
    }
  },

  mounted() {
    if (this.item.IsSelected) {
      this.markAsSelected()
    }
  },

  methods: {
    displaySelection() {
      this.$emit('displaySelected', this.item.NameInHebrew)
    },

    markAsSelected() {
      this.checkbox = true
    },
  },
}
</script>

<style lang="scss" scoped>
.dr-checkbox {
  width: fit-content;
  margin: 0 auto;
  display: inline-flex;
}

.v-input--selection-controls__input {
  margin-left: 0 !important;
}

.background-checkbox {
  background: #f2f2f2;
}

.check-item {
  margin: 5px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
}
.check-item .theme--light.v-label {
  color: #000;
}

@media only screen and (min-width: 960px) {
  .check-item {
    background: #f2f2f2;
    margin: 5px;
    height: 100px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
  }
}

@media only screen and (min-width: 600px) {
}
</style>
